export const showCutString = (str: string, max: number = 20) => {
    if (str.length > max) {
        return `${str.substring(0, 20)}…`;
    }

    return str;
};


// WEBPACK FOOTER //
// ../helpers/src/showCutString.ts